// extracted by mini-css-extract-plugin
export default {"ConnectModal":"ConnectModal_DIQ91","cardsBlock":"cardsBlock_bYz6Q","modalBtn":"modalBtn_XZLcj","link":"link_GnXnQ"};